interface VideoPlayerType {
	videoUrl: string;
}

export function ModalVideoPlayer({ videoUrl }: VideoPlayerType) {
	return (
		<div style={{ width: '100%', height: '120px', overflow: 'hidden' }}>
			<video
				controls
				style={{
					width: '100%',
					height: '100%',
					objectFit: 'cover',
				}}
			>
				<source src={videoUrl} type="video/mp4" />
			</video>
		</div>
	);
}

export default function VideoPlayer({ videoUrl }: VideoPlayerType) {
	return (
		<div>
			<video controls width={'200px'} height={'auto'}>
				<source src={videoUrl} type="video/mp4" />
			</video>
		</div>
	);
}
